module.exports = __webpack_public_path__ + "static/media/transpRollet4.6ace6250.jpg";